class ShareButton extends window.BAO.DetailsDisclosure {
  static get requiredElements () {
    return super.requiredElements.concat([
      'trigger',
      'message',
      'input',
      'copy',
    ])
  }

  connectedCallback () {
    super.connectedCallback()

    this.urlToShare = this.els.input.element.value
      ? this.els.input.element.value
      : document.location.href

    if (navigator.share && this.els?.trigger?.exists) {
      this.els.details.element.setAttribute('hidden', '')
      this.els.trigger.element.removeAttribute('hidden')
    }
  }

  setupListeners () {
    super.setupListeners()

    if (navigator.share && this.els?.trigger?.exists) {
      this.listeners.add(this.els.trigger.element, 'click', () => {
        navigator.share({
          url: this.urlToShare,
          title: document.title,
        })
      })
    } else {
      this.copyToClipboard = this.copyToClipboard.bind(this)
      this.listeners.add(
        this.els.summary.element,
        'click',
        this.copyToClipboard,
      )

      this.listeners.add(this.els.close.element, 'click', this.close)
    }
  }

  copyToClipboard () {
    navigator.clipboard.writeText(this.els.input.element.value).then(() => {
      this.els.message.element.classList.remove('util-ScreenReaderOnly')
      this.els.message.element.textContent = this.els.message.element.dataset.successMessage

      this.els.close.element.removeAttribute('hidden')
      this.els.close.element.focus()

      this.els.copy.element.setAttribute('hidden', '')
    })
  }

  updateUrl (url) {
    this.urlToShare = url
    this.els.input.element.value = url
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton)
}
